/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';
import { intializeContactData } from '../component/planContactForm';

const axiosPayLoad = {
  allPlans: { data: [] },
  searchScreenData: {},
  rebateProgramCode: [],
  openComments: false,
  plansByCgp: [],
  allClientDropDown: [],
  allGropsForClientDropDown: [],
  allRebateProgramCode: [],
  saveOrUpdateMessage: '',
  allContactTypeDropDownClient: [],
  allContactTypeDropDownGroup: [],
  allContactTypeDropDownPlan: [],
  allContactTypeDropDownProvider: [],
  existingContactDetailsClient: [],
  existingContactDetailsGroup: [],
  existingContactDetailsPlan: [],
  existingContactDetailsProvider: [],

  contactDetailsClient: {},
  contactDetailsGroup: {},
  contactDetailsPlan: {},
  contactDetailsProvider: {},

  updateOrSaveContactDetailsMessage: '',
  deleteMessageResponse: {
    message: null,
    status: '',
    data: null,
    timestamp: '',
  },
  deletePlan: { index: '', shouldDeletePlan: false },
  planSearchCriteria: {
    radioButton: 'P',
  },
  allContactData: intializeContactData,
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_PLANS:
      return { ...state, allPlans: action.allPlans };
    case actionTypes.GET_ALL_PLAN_BY_REBATE_PROGRAM_CODE:
      return { ...state, rebateProgramCode: action.rebateProgramCode };
    case actionTypes.OPEN_COMMENTS:
      return { ...state, openComments: action.openComments };
    case actionTypes.GET_PLANS_BY_CGP:
      // action.plansByCgp&&action.plansByCgp.length&&action.plansByCgp.length>0?
      action.plansByCgp.forEach((item, i) => {
        item.index = i;
        item.startDt = item.cgpId.startDt;
      });

      return { ...state, plansByCgp: action.plansByCgp };
    case actionTypes.GET_ALL_CLIENTS_FOR_PLAN:
      return { ...state, allClientDropDown: action.allClientDropDown };
    case actionTypes.GET_ALL_GROUPS_FOR_CLIENT_DROPDOWN:
      return {
        ...state,
        allGropsForClientDropDown: action.allGropsForClientDropDown,
      };
    case actionTypes.GET_REBATE_PROGRAM_CODE_FROM_CGP:
      return { ...state, allRebateProgramCode: action.allRebateProgramCode };

    case actionTypes.SAVE_OR_UPDATE:
      return { ...state, saveOrUpdateMessage: action.saveOrUpdateMessage };

    case actionTypes.GET_CONTACT_TYPE_CLIENT:
      return {
        ...state,
        allContactTypeDropDownClient: action.allContactTypeDropDownClient,
      };

    case actionTypes.GET_CONTACT_TYPE_GROUP:
      return {
        ...state,
        allContactTypeDropDownGroup: action.allContactTypeDropDownGroup,
      };
    case actionTypes.REDUX_STORE_DATA_SEARCH_SER:
      return { ...state, searchScreenData: action.payload };
    case actionTypes.GET_CONTACT_TYPE_PLAN:
      return {
        ...state,
        allContactTypeDropDownPlan: action.allContactTypeDropDownPlan,
      };
    case actionTypes.GET_CONTACT_TYPE_PROVIDER:
      return {
        ...state,
        allContactTypeDropDownProvider: action.allContactTypeDropDownProvider,
      };
    case actionTypes.GET_EXISTING_CONTACT_DETAILS_CLIENT:
      return {
        ...state,
        existingContactDetailsClient: action.existingContactDetailsClient,
      };
    case actionTypes.GET_EXISTING_CONTACT_DETAILS_GROUP:
      return {
        ...state,
        existingContactDetailsGroup: action.existingContactDetailsGroup,
      };
    case actionTypes.GET_EXISTING_CONTACT_DETAILS_PLAN:
      return {
        ...state,
        existingContactDetailsPlan: action.existingContactDetailsPlan,
      };
    case actionTypes.GET_EXISTING_CONTACT_DETAILS_PROVIDER:
      return {
        ...state,
        existingContactDetailsProvider: action.existingContactDetailsProvider,
      };
    case actionTypes.GET_CONTACT_DETAILS_CLIENT:
      return { ...state, contactDetailsClient: action.contactDetailsClient };
    case actionTypes.GET_CONTACT_DETAILS_GROUP:
      return { ...state, contactDetailsGroup: action.contactDetailsGroup };
    case actionTypes.GET_CONTACT_DETAILS_PLAN:
      return { ...state, contactDetailsPlan: action.contactDetailsPlan };
    case actionTypes.GET_CONTACT_DETAILS_PROVIDER:
      return {
        ...state,
        contactDetailsProvider: action.contactDetailsProvider,
      };
    case actionTypes.UPDATE_CONTACT_DETAILS:
      return {
        ...state,
        updateOrSaveContactDetailsMessage:
          action.updateOrSaveContactDetailsMessage,
      };
    case actionTypes.DELETE_PLAN_DETAILS:
      return { ...state, deleteMessageResponse: action.deleteMessageResponse };
    case actionTypes.DELETE_PLAN_HANDLE_FROM_GRID_COMPONENT:
      return { ...state, deletePlan: action.deletePlan };
    case actionTypes.UPDATE_PLAN_WHEN_USER_UPDATE:
      // return { ...state, plansByCgp: action.plansByCgp }
      let data = state.plansByCgp.map((item) => {
        if (
          item.index &&
          action &&
          action.plansByCgp &&
          action.plansByCgp.index === item.index
        ) {
          return action.plansByCgp;
        }
        return item;
      });
      return { ...state, plansByCgp: data };

    case actionTypes.ADD_NEW_DATE:
      return { ...state, plansByCgp: action.newDate };
    case actionTypes.CREATE_NEW_PLAN:
      return { ...state, plansByCgp: action.plansByCgp };
    case actionTypes.SET_PLAN_SEARCH_VALUES:
      return { ...state, planSearchCriteria: action.payload };
    case actionTypes.SOFT_DELETE_DATA:
      return { ...state, softDeleteRowData: action.softDeleteRowData };
    case actionTypes.PLAN_DATA_ACTION_TYPES:
      return { ...state, planRebateClientSearchData: action.payload };
    case actionTypes.UPDATE_DATES_ROWS:
      return { ...state, datesRows: action.datesRows };
    case actionTypes.SAVE_CONTACT_DATA:
      return { ...state, allContactData: action.contactData };
    case actionTypes.RESET_CONTACT_DATA:
      return { ...state, allContactData: intializeContactData };
    case actionTypes.CONTACT_FORM_VALIDITY:
      return { ...state, isValidContact: action.isValidContactForm };
    case actionTypes.PLAN_TAB_DATA:
      return { ...state, planTabData: action.planTabData };
    case actionTypes.CLEAR_REDUX_DATA:
      return { ...axiosPayLoad };
    default:
      return state;
  }
};

export default reducer;
